import { render, staticRenderFns } from "./newPresentation.vue?vue&type=template&id=14353abf&scoped=true"
import script from "./newPresentation.vue?vue&type=script&lang=js"
export * from "./newPresentation.vue?vue&type=script&lang=js"
import style0 from "./newPresentation.vue?vue&type=style&index=0&id=14353abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14353abf",
  null
  
)

export default component.exports